export default "__VITE_ASSET__CpWoW5Ot__"